import React from 'react'

import Image from '@components/Content/WordPress/Image'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'
import Section from '@components/Layout/Section'

import { wpShowcaseType } from '@contracts/acf/showcase'

import IconAccordion from '../IconAccordion/IconAccordion'
import * as styles from './Showcase.module.scss'

interface Props {
	data: wpShowcaseType
	theme?: 'normal' | 'dark'
	altStyle?: boolean
}

const Showcase: React.FunctionComponent<Props> = ({ data, theme, altStyle }) => {
	const showcaseStyles = [styles.showcase]
	const subtextStyles = [styles.subtext]
	const containerStyles = [styles.container]

	if (altStyle) {
		containerStyles.push(styles.altContainer)
	}

	if (theme == 'dark') {
		showcaseStyles.push(styles.dark)
	}

	if (data.reverse) {
		showcaseStyles.push(styles.reverse)
	}

	return (
		<Section className={showcaseStyles.join(' ')} containerClassName={containerStyles.join(' ')}>
			<div className={styles.secondary}>
				{data.showcaseType === 'image' && data.image ? <Image image={data.image} altText="" /> : null}
				{data.showcaseType === 'title' && data.alternateTitle ? (
					<Wysiwyg data={data.alternateTitle} className={styles.alternateTitle} />
				) : null}
			</div>

			<div className={styles.main}>
				{data.title && (
					<h2 className={styles.title}>
						<Wysiwyg data={data.title} />
					</h2>
				)}

				{data.subtitle && <h3 className={styles.subtitle}>{data.subtitle}</h3>}

				{data.text && <Wysiwyg data={data.text} className={subtextStyles.join(' ')} />}

				{data.accordion && data.accordion.accordions ? <IconAccordion data={data.accordion} /> : null}
			</div>
		</Section>
	)
}

export default Showcase
